export const getCompanyDomain = () => {
  const hostname = window.location.hostname;
  const hostnameParts = hostname.split(".");

  if (
    (hostnameParts.at(-1) === "localhost" ||
      hostnameParts.at(-1) === "frontend") &&
    hostnameParts.length > 1
  ) {
    return hostnameParts[0];
  }

  if (hostnameParts.includes("staging") && hostnameParts.length > 5) {
    return hostnameParts[0];
  }

  if (!hostnameParts.includes("staging") && hostnameParts.length > 4) {
    return hostnameParts[0];
  }

  return null;
};

export const setCompanyDomain = (domain: string) => {
  try {
    window.location.replace(`${location.protocol}//${domain}.${location.host}`);
  } catch (error) {
    console.error("Error when we tried to signIn:", error);
  }
};

export const clearCompanyDomain = () => {
  const domain = getCompanyDomain();

  if (domain) {
    const currentUrl = window.location.href;
    const currentHostname = window.location.hostname;
    const newHostname = currentHostname.slice(domain.length + 1);
    const newUrl = currentUrl
      .replace(currentHostname, newHostname)
      .replace("/login", "");

    window.location.href = newUrl;
  }
};
